import * as Yup from 'yup';
import formModel from './permissionsFormModel';

const {
    formField: {
        name,
        icon,
        slug,
        description,
        application_id,
        childrens   
    }
} = formModel;

export default Yup.object().shape({
    [name.name]: Yup.string().required(name.requiredErrorMsg),
    [icon.name]: Yup.string().required(icon.requiredErrorMsg),
    [slug.name]: Yup.string().required(slug.requiredErrorMsg),
    [description.name]: Yup.string().required(description.requiredErrorMsg),
    [application_id.name]: Yup.object().shape({
        value: Yup.string().required(),
        label: Yup.string().required()
    }).default(undefined).required(application_id.requiredErrorMsg),
    [childrens.name]: Yup.string().required(childrens.requiredErrorMsg).test(
        'is-json',
        'Debe ser un JSON válido (Ej: [])',
        (value) => {
            try {
                if (value) JSON.parse(value);
                return true;
            } catch (e) {
                return false;
            }
        }
    )
});
